<template>
  <div class="home-card-info-left">
    <div class="home-card-info-left-card">
      <div
        class="home-card-info-left-card-controller"
        :class="
          card.name
            ? 'home-card-info-left-card-change-card'
            : 'home-card-info-left-card-add-card'
        "
        @click="viewClick"
      ></div>
      <div
        class="home-card-info-left-card-portrait"
        :class="sexClass"
        @click="viewClick"
      />
      <div v-show="card.name">
        <div class="home-card-info-left-card-user">
          <div class="home-card-info-left-card-user-name">
            {{ card.name }}
          </div>
          <div class="home-card-info-left-card-user-card">
            {{ card.cardNo }}
          </div>
        </div>
      </div>
      <!--<div class="home-card-info-qrcode" @click="qrcodeClick">
        <span>多码融合码</span>
        <img
          class="home-card-info-user-qrcode"
          :src="require('@assets/home_qrcode.png')"
          alt=""
        />
      </div>
      -->
    </div>
    <div class="home-card-info-left-serve" @click="goServe()">
      <img :src="require(`@assets/ic_recharge.png`)" alt="" />
      <div>门诊充值</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    card: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  computed: {
    sexClass() {
      var sex = 0;
      if (this.card && this.card.idCard) {
        const value = this.card.idCard;
        if (value.length === 15) {
          sex = value.substr(14, 1) % 2 || 2;
        }
        if (value.length === 18) {
          sex = value.substr(16, 1) % 2 || 2;
        }
      }
      if (sex == 1) {
        return "home-card-info-portrait-man";
      } else if (sex == 2) {
        return "home-card-info-portrait-woman";
      }
      return "home-card-info-portrait";
    }
  },
  methods: {
    viewClick() {
      if (this.card) {
        this.$router.push({
          name: "change-card"
        });
      } else {
        this.$router.replace({
          name: "mine",
          query: {
            type: "outpatient"
          }
        });
      }
    },
    goServe() {
      this.$router.push({
        name: "recharge",
        query: {
          ftype: "1",
          qrtype: "1"
        }
      });

      /*
      if (this.$dialog && this.$dialog.alert) {
        this.$dialog.alert({ message: "该功能暂不可用" });
      } else if (this.$toast) {
        this.$toast("该功能暂不可用");
      } else {
        alert("该功能暂不可用");
      }
      */
    },
    qrcodeClick() {
      this.$http.route("/ecode", "1");
    }
  }
};
</script>

<style lang="less" scoped>
.home-card-info-left {
  width: 50%;
  &-serve {
    display: flex;
    align-items: center;
    // width: 100%;
    height: 5.27rem;
    margin: 0.7rem 0.4rem 0 0;
    color: #f49a00;
    font-weight: 500;
    font-size: 1rem;
    background-image: url("~@/assets/bg_home_topfunction_orange.png");
    background-repeat: no-repeat;
    background-position: right center;
    background-size: 100% 100%;
    img {
      flex-shrink: 0;
      width: 2.37rem;
      height: 2.37rem;
      margin-right: 0.7rem;
      margin-left: 1rem;
    }
  }
  &-card {
    position: relative;
    display: flex;
    // flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 5.27rem;
    margin-right: 0.3rem;
    text-align: center;
    background-image: url("~@/assets/bg_home_patient_info.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 0.5rem;
    &-controller {
      position: absolute;
      top: 0;
      left: 0;
      height: 1.33rem;
    }

    &-change-card {
      width: 2.73rem;
      background-image: url("~@/assets/ic_home_patient_change_card.png");
      background-repeat: no-repeat;
      background-size: 100%;
    }

    &-add-card {
      width: 4.73rem;
      background-image: url("~@/assets/ic_home_patient_add_card.png");
      background-repeat: no-repeat;
      background-size: 100%;
    }

    &-portrait {
      width: 3rem;
      height: 3rem;
      // margin-top: 1rem;
      // vertical-align: middle;
      background-image: url("~@/assets/ic_user_portrait_common.png");
      background-size: 3rem;

      &-man {
        background-image: url("~@/assets/ic_user_portrait_man.png");
      }
      &-woman {
        background-image: url("~@/assets/ic_user_portrait_woman.png");
      }
    }

    &-user {
      margin-top: 0.1rem;
      color: #108eee;
      &-name {
        align-items: center;
        font-weight: 600;
        font-size: 1.2rem;

        span {
          margin-left: 0.5rem;
          font-weight: 400;
          font-size: 0.73rem;
          background: rgba(16, 142, 238, 0.15);
        }
      }

      &-card {
        // margin: 0.2rem 0.5rem 0.2rem 0.5rem;
        font-size: 0.87rem;
        line-height: 0.8rem;
        text-align: center;
        div {
          padding: 0 0.4rem;
          color: #108eee;
          font-size: 0.3rem;
          background: rgba(16, 142, 238, 0.15);
        }
      }
    }

    &-pannel {
      top: 0.5rem;
      right: 50%;
      display: flex;
      align-items: center;
      float: right;
      padding: 0 0.31rem 0 0.5rem;
      color: white;
      font-size: 0.5rem;
      background: #09f;
      border-radius: 0 0.25rem 0 1.44rem;
      i {
        margin-right: 0.2rem;
      }
    }
    &-qrcode {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 8.17rem;
      height: 2rem;
      margin: 0.5rem 1.5rem;
      color: white;
      font-size: 1rem;
      background: #09f;
      border-radius: 1rem;

      img {
        width: 1rem;
        height: 1rem;
      }
    }
  }
}
</style>
